/**
 * ÜRÜN BÖLÜMLERİ — YEREL SÖZLÜK (tr / en)
 *
 * NEDEN AYRI DOSYA?
 * `src/translations.js` ve `src/components/LanguageProvider.js` içerik ajanının
 * dosyalarıdır; bu iş kapsamında onlara DOKUNULMAZ. Bu yüzden dört ürün
 * bölümünün metinleri burada, kendi klasöründe tutulur. Dil anahtarı yine
 * `useLang()` üzerinden okunur — yani site genelindeki tek dil kaynağıyla
 * eşzamanlı çalışır, ikinci bir dil durumu yaratılmaz.
 *
 * İleride içerik ajanı bu metinleri `translations.js`'e taşımak isterse
 * `UrunBolumleri` bileşeni `metinler` prop'u ile dışarıdan da beslenebilir.
 */

const metinler = {
  tr: {
    rozet: 'WhowSell Ürünleri',
    crm: {
      etiket: 'WhowSell CRM',
      baslik: 'Satışlarınız artık tahmin değil, ölçüm',
      metin:
        'Mağazalarınız, siparişleriniz ve ekibiniz tek panelde birleşir. Dağınık tablolarla geçen saatler yerine, kararınızı verecek sayıyı doğrudan görürsünüz.',
      maddeler: [
        'Tüm mağazalar tek ekranda',
        'Sipariş ve ciro takibi',
        'Ekip ve yetki yönetimi',
      ],
      // ProfitCard metinleri (birebir karşılıkları)
      oncesiRozet: 'Öncesi',
      sonrasiRozet: 'WhowSell ile',
      oncesiBaslik: 'Dağınık veriyle yönetilen satış',
      oncesiMetin:
        'Rakamlar farklı dosyalarda durduğu sürece hangi ürünün kazandırdığını ancak ay sonunda anlarsınız.',
      sonrasiBaslik: 'WhowSell ile',
      sonrasiMetin: 'Aynı veri tek çizgide birleşir; yön anında görünür.',
      ipucuHover: 'Farkı görmek için üzerine gelin',
      ipucuDokunma: 'Farkı görmek için dokunun',
    },
    radar: {
      etiket: 'WhowSell Radar',
      baslik: 'Ürünü almadan önce cevabı görün',
      metin:
        'Radar; satış hızını, satıcı sayısını ve fiyat seyrini birlikte okur. Her ürün için tek bir net karar bırakır: Go, Caution ya da Avoid.',
      maddeler: [
        'Canlı pazar taraması',
        'BSR ve satış trendi',
        'Net karar rozeti',
      ],
      aiSonuclari: 'YAPAY ZEKÂ SONUÇLARI',
      sonuc: 'sonuç',
      satirSec: 'Ayrıntı için satıra bakın',
      canliVeri: 'Canlı veri',
      kapat: 'Kapat',
      kucult: 'Küçült',
      yenidenAc: 'Yeniden aç',
      kapali: 'Paneli yeniden aç',
    },
    ai: {
      etiket: 'Suspend AI',
      baslik: 'Kararı hazırlayan yapay zekâ',
      metin:
        'Suspend AI, verinizi okuyup size hazır bir özet bırakır. Ne olduğunu değil, ne yapmanız gerektiğini söyler.',
      maddeler: [
        'Veriden doğrudan öneri',
        'Kendi verinizle sınırlı',
        'Her adımda gerekçe',
      ],
    },
    server: {
      etiket: 'WhowSell Server',
      baslik: 'Altyapı hiç durmadan çalışır',
      metin:
        'Sunucu katmanı; taramaları, senkronizasyonu ve bildirimleri siz uyurken de sürdürür. Panelde gördüğünüz her sayının arkasında bu katman vardır.',
      maddeler: [
        'Kesintisiz çalışma',
        'Otomatik senkronizasyon',
        'İzlenebilir kayıt',
      ],
    },
    urunler: {
      h1: 'Kablosuz Kulaklık — Aktif Gürültü Engelleme',
      h2: 'Bluetooth Kulaklık — 40 Saat Pil',
      h3: 'Spor Kulaklığı — Su Geçirmez',
      y1: 'Kaymaz Yoga Matı — 6 mm',
      y2: 'Seyahat Yoga Matı — Katlanır',
      y3: 'Doğal Kauçuk Yoga Matı',
      c1: 'Deri iPhone Kılıfı — MagSafe',
      c2: 'Şeffaf iPhone Kılıfı — Darbe Korumalı',
      c3: 'Silikon iPhone Kılıfı — Ekonomik',
      l1: 'Akıllı LED Şerit — 10 m',
      l2: 'TV Arkası LED Şerit — USB',
      l3: 'RGBIC LED Şerit — Uygulama Kontrollü',
    },
  },
  en: {
    rozet: 'WhowSell Products',
    crm: {
      etiket: 'WhowSell CRM',
      baslik: 'Your sales stop being a guess',
      metin:
        'Stores, orders and your team come together on one panel. Instead of hours lost in scattered sheets, you see the number your decision depends on.',
      maddeler: [
        'Every store on one screen',
        'Order and revenue tracking',
        'Team and permission control',
      ],
      oncesiRozet: 'Before',
      sonrasiRozet: 'With WhowSell',
      oncesiBaslik: 'Sales run on scattered data',
      oncesiMetin:
        'While the numbers live in separate files, you only learn which product earned at the end of the month.',
      sonrasiBaslik: 'With WhowSell',
      sonrasiMetin: 'The same data joins one line; the direction shows up at once.',
      ipucuHover: 'Hover to see the difference',
      ipucuDokunma: 'Tap to see the difference',
    },
    radar: {
      etiket: 'WhowSell Radar',
      baslik: 'See the answer before you buy',
      metin:
        'Radar reads sales velocity, seller count and price movement together. It leaves one clear call per product: Go, Caution or Avoid.',
      maddeler: [
        'Live market scan',
        'BSR and sales trend',
        'One clear verdict',
      ],
      aiSonuclari: 'AI RESULTS',
      sonuc: 'results',
      satirSec: 'Check a row for detail',
      canliVeri: 'Live data',
      kapat: 'Close',
      kucult: 'Minimize',
      yenidenAc: 'Reopen',
      kapali: 'Reopen the panel',
    },
    ai: {
      etiket: 'Suspend AI',
      baslik: 'The AI that prepares the decision',
      metin:
        'Suspend AI reads your data and hands back a finished summary. It does not tell you what happened; it tells you what to do.',
      maddeler: [
        'Advice straight from data',
        'Limited to your own data',
        'A reason at every step',
      ],
    },
    server: {
      etiket: 'WhowSell Server',
      baslik: 'The infrastructure never stops',
      metin:
        'The server layer keeps scans, syncing and notifications running while you sleep. Every number you see on the panel stands on this layer.',
      maddeler: [
        'Always-on operation',
        'Automatic syncing',
        'Traceable records',
      ],
    },
    urunler: {
      h1: 'Wireless Headphones — Active Noise Cancelling',
      h2: 'Bluetooth Headphones — 40h Battery',
      h3: 'Sport Earbuds — Waterproof',
      y1: 'Non-Slip Yoga Mat — 6 mm',
      y2: 'Travel Yoga Mat — Foldable',
      y3: 'Natural Rubber Yoga Mat',
      c1: 'Leather iPhone Case — MagSafe',
      c2: 'Clear iPhone Case — Drop Protection',
      c3: 'Silicone iPhone Case — Budget',
      l1: 'Smart LED Strip — 10 m',
      l2: 'TV Backlight LED Strip — USB',
      l3: 'RGBIC LED Strip — App Controlled',
    },
  },
};

export function urunMetinleri(lang) {
  return metinler[lang] || metinler.en;
}

export default metinler;
